import {isObject} from 'lodash-es';
import moment from 'moment';

export default function FriendlyAttributesFilter(gettextCatalog, appSettings) {
  'ngInject';

  const hasMin = val => val.hasOwnProperty('min');
  const hasMax = val => val.hasOwnProperty('max');
  const minStatment = min => `> ${min}`;
  const maxStatment = max => `< ${max}`;
  const minMaxStatment = (min, max) => `${min} - ${max}`;
  const getValue = val => {
    //handle when value is date or date time
    if (typeof val === 'string' && moment(val).isValid()) {
      const dateFormat = appSettings.GetDateFormat();
      const dateTimeFormat = `${dateFormat} hh:mm A`;
      const date = moment(val);
      if (val.indexOf('T') > -1 && val.endsWith('Z')) {
        return date.format(dateTimeFormat);
      }
      return date.format(dateFormat);
    }
    return val;
  };

  const buildRangeStatment = val => {
    let statment = '';
    if (hasMin(val) && hasMax(val)) {
      const min = getValue(val.min);
      const max = getValue(val.max);
      statment = minMaxStatment(min, max);
    } else if (hasMin(val) && !hasMax(val)) {
      const min = getValue(val.min);
      statment = minStatment(min);
    } else {
      const max = getValue(val.max);
      statment = maxStatment(max);
    }
    return statment;
  };

  return function(value) {
    if (isObject(value)) {
      //in case any value
      if (value.hasOwnProperty('any')) {
        return gettextCatalog.getString('any');
      }
      //in case MultipleValues
      if (Array.isArray(value)) {
        return value.map(val => (val.text ? val.text : val)).join(', ');
      }
      //in case range of values
      if (hasMin(value) || hasMax(value)) {
        return buildRangeStatment(value);
      }
      //if none of the above (string object ...)
      return value;
    } else {
      //none object value
      return value;
    }
  };
}
